<template>
    <div class="row d-flex flex-column align-center py-5"  v-if="loginbox">
        <h4 class="text-center fw-bold mb-4 d-none">LOGIN</h4>
        <div class="col-lg-6 d-flex flex-column align-center" style="position: relative; z-index: 0;">
            <v-card style=" width:80%; border-radius:7px;box-shadow: 0px 0px 8px 0px black; " outlined
                v-click-outside="onClickOutside">
                <div class="row d-flex align-items-center justify-content-center">
                    <div class="col-md-12 main-page">
                        <div class="bg-light main-page mx-auto p-3" style="background-color:#f8b2b2; width: 100%; height: auto;">
                            <!-- <div class="col-12 pe-1 pt-1 d-flex justify-end" @click="closeLoginBox()">
                                <v-icon style="color:navy; cursor:pointer" size="small">mdi-close-circle</v-icon>
                            </div> -->
                            <div class="d-flex align-center w-100">
                                <div class="m-2 ms-0 rounded-circle lockIcon d-flex align-center justify-center">
                                    <i class="bi bi-unlock fs-4 p-4"></i>
                                </div>
                                <div>
                                    <h4 class="m-0">Sign in</h4>
                                    <p class="m-0 f-size-12">Sign in and Get lots of Cashback Rewards and Discount</p>
                                </div>
                            </div>

                            <v-form ref="form" class="py-3 w-100" v-if="loginshow" v-model="valid" @submit.prevent="loginsubmitForm">

                                <v-text-field v-model="loginuser.userEmail" :rules="eMail" label="Email"
                                    variant="outlined" placeholder="Enter your Email"
                                    style="font-size: 15px !important"></v-text-field>
                                <!-- <span style="color: red;">invalid Username</span><br> -->

                                <v-text-field v-model="loginuser.userPass" :rules="uPass" label="Password"
                                    placeholder="Enter your password" variant="outlined" required
                                    :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                                    :type="visible ? 'text' : 'password'" @click:append-inner="visible = !visible"
                                    style="font-size: 15px !important"></v-text-field>
                                <!-- <span style="color: red;">invalid password</span> -->

                                <div class="row">
                                    <div class="col-6">
                                        <v-checkbox v-model="terms" label="Remember Me"></v-checkbox>
                                    </div>
                                    <div class="col-6">
                                        <span style="position: relative;top: 15px;">
                                            <p class="forgotStyle m-0" @click="this.loginshow = false, this.forgotshow = true">
                                                Forgot Password</p>
                                        </span>
                                    </div>
                                </div>


                                <div>
                                    <p class="text-danger" v-if="errorMsg">Incorrect Email or Password.</p>
                                </div>



                                <div class="d-flex mb-3">
                                    <div class="col-9 d-flex justify-end">
                                        <v-btn style="background-color:#26225e; color:white" width="60%"
                                            :disabled="btnDisabled" type="submit">Login</v-btn>
                                    </div>
                                    <div class="col-3 ps-1 d-flex justify-end">
                                        <v-progress-circular v-if="loadLogin" :width="3" style="color:navy"
                                            indeterminate></v-progress-circular>
                                    </div>
                                </div>
                                <!-- <v-divider></v-divider> -->

                                <p class="text-center" style="font-weight: 500;font-size: 15px;">Create an Account
                                    <span @click="signUp" style="cursor: pointer;"> &nbsp;
                                        <!-- <b style="color:navy">Sign Up</b> -->
                                        <a href="/register" style="color:navy;text-decoration:none;font-weight:600;">Register</a></span>
                                </p>
                            </v-form>




                            <v-form ref="form" v-if="forgotshow" v-model="valid" @submit.prevent="submitResetForm"
                                style="width: 90%;">

                                <h5 class="mt-2 text-center" v-if="forgotshow">Reset your Password</h5>

                                <v-text-field v-model="resetDetail.resetMail" :rules="eMail" label="Email"
                                    variant="outlined" placeholder="Enter your email"
                                    style="height:55px;font-size: 15px !important"></v-text-field>
                                <!-- <span style="color: red;">invalid Username</span><br> -->

                                <div class="row justify-center">

                                    <div class="col-10 my-3 text-center">
                                        <span @click="this.loginshow = true, this.forgotshow = false"
                                            style="font-weight:500;font-size:13px;letter-spacing: 1px;">
                                            Remember your password? <span
                                                style="color:#0D6EFD; text-decoration:underline; cursor:pointer">Login</span>
                                        </span>
                                    </div>
                                </div>


                                <div>
                                    <p class="text-danger" v-if="errforget">Email Not Found.</p>
                                </div>



                                <div class="d-flex mb-3">
                                    <div class="col-9 d-flex justify-end">
                                        <v-btn style="background-color:#26225e; color:white" width="60%"
                                            :disabled="btnDisabled" type="submit">Submit</v-btn>
                                    </div>
                                    <div class="col-3 ps-1 d-flex justify-end">
                                        <v-progress-circular v-if="loadforget" :width="3" style="color:navy"
                                            indeterminate></v-progress-circular>
                                    </div>
                                </div>
                            </v-form>



                            <div v-if="emailsentMsg">
                                <div class="d-flex justify-center align-center p-3">
                                    <p>You will receive a link to reset the password, if your email is already registered.
                                        Please follow the instructions in the email to reset your password.</p>
                                </div>

                                <div class="d-flex justify-center align-center p-3">
                                    <span @click="this.loginshow = true, this.forgotshow = false, this.emailsentMsg = false"
                                        style="font-weight:500;font-size:13px;letter-spacing: 1px;">
                                        Remember your password? <span
                                            style="color:#0D6EFD; text-decoration:underline; cursor:pointer">Login</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card>
        </div>
    </div>


    <div class="text-center" v-if="dataloader">
        <dataloader></dataloader>
    </div>

    <!-- <div v-if="registerCom">
        <registerCom />
    </div> -->
</template>


<script>
// import registerCom from '@/components/registerCom.vue';
import axios from 'axios'
// import dataloader from "@/components/dataLoder.vue";
import { getConfigDataFromLocalStorage } from '@/localStorageData/localStorageUtil.js';

export default {
    components: {
        // registerCom
            // dataloader,
    },
    data() {
        return {
            dataloader: true,
            loginbox: true,
            registerCom: false,
            terms: false,
            visible: false,
            loadLogin: false,
            btnDisabled: false,
            errorMsg: false,

            loginshow: true,
            forgotshow: false,
            emailsentMsg: false,
            resetshow: false,
            loadforget: false,
            errforget: false,
            userName: "",
            userEmail: "",

            customKey: "qt3cU5nWjV2OPeQBEYkwD4adr8oy9I",
            customMail: "sarath@gmail.com",



            loginuser: {
                userEmail: "",
                userPass: "",
                confirmPass: "",
            },

            resetDetail: {
                resetMail: "",
            },

            eMail: [
                v => !!v || 'Please enter your email',
                v => /.+@.+/.test(v) || 'E-mail must be valid',
            ],
            uPass: [
                v => !!v || 'Please enter your Password'
            ],

            loginReq: {
                "request_type": "user_login",
                "email": "",
                "password": "",
                "portal_id": "11111",
                "token": "Tc7RQaX79Hrx5CFK"
            },

            forgetDetails: {
                "request_type": "forgot_password",
                "email": "irwogms@gmail.com",
                "user_id": "443355",
                "portal_id": "11111"
            },

            loginUrl: "",
            forgotPassword: "",





            // Register Code ----->

            valid: false,

            registerbox: false,
            loginSection: true,
            // terms: false,
            // visible: false,

            regForm: true,
            regMsg: false,
            registerMsg: "",
            loadRegister: false,
            // btnDisabled: false,

            personal: {
                username: "",
                email: "",
                password: "",
                rePassword: ""
            },
            


            // userName: [
            //     v => !!v || 'Please enter your Username',
            //     v => (v.length >= 3) || 'Name must be greater than 3 ',
            // ],

            // eMail: [
            //     v => !!v || 'E-mail is required',
            //     v => /.+@.+/.test(v) || 'E-mail must be valid',
            // ],

            passWord: [
                v => !!v || 'Please enter your Password',
                // v => (v && v.length >= 8) || 'Password must be at least 8 characters',
                // v => (v && v.length <= 20) || 'Password must be less than 20 characters',
                // v => (v && /[a-z]/.test(v)) || 'Password must contain at least one lowercase letter',
                // v => (v && /[!@#$%^&*]/.test(v)) || 'Password must contain at least one special character'
            ],
            repassWord: [
                v => !!v || 'Please enter your Re-password',
                v => v === this.personal.password || 'Passwords do not match'
            ],

            // strResult: "0123456789",

            // user_reqId:"",


            registerReq: {
                "request_type": "user_register",
                "user_name": "",
                "email": "",
                "password": "1234567890",
                "portal_id": "11111",
                "portal_group_id": "11111",
                "user_id": "",
                "token": "Tc7RQaX79Hrx5CFK"
            },

            registerUrl: "",

            // Register Code End ----->
        }
    },
    methods: {

        // signUp() {
        //     this.registerbox = true
        //     this.loginbox = false
        // },


        onClickOutside() {
            // this.loginbox = false
            console.log(this.loginbox, "5555555")
        },


        loginsubmitForm() {
            if (this.valid) {
                console.log(this.loginuser, 'vvvvaaaallll')

                this.loadLogin = true
                this.btnDisabled = true

                this.loginReq.email = this.loginuser.userEmail
                this.loginReq.password = this.loginuser.userPass
                console.log(this.loginReq, 'kkkk.....')

                // axios.post('https://dl.buymytrip.com/api/b2clogin', this.loginReq, {
                axios.post(this.loginUrl, this.loginReq, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then(response => {
                        console.log('Response:', response.data);
                        localStorage.setItem("loginuser", JSON.stringify(response.data))
                        this.errorMsg = false

                        // console.log(response.data.user,'.....Response...:');

                        // this.forgetDetails.user_id=response.data.user.user_id

                        // console.log(this.forgetDetails.user_id,'.....Response..11111.:');


                        this.loginbox = true

                        localStorage.setItem('value', true)
                        // JSON.stringify(localStorage.setItem('loginDatas', this.loginuser))
                        let logindata = JSON.stringify(this.loginuser)
                        localStorage.setItem("loginDatas", logindata)

                        setInterval(() => {
                            location.reload();
                        }, 500);

                    })
                    .catch(error => {
                        console.error('Error:', error.response ? error.response.data : error.message);
                        this.errorMsg = true
                        // alert("Incorrect email or password...")
                        this.loadLogin = false
                        this.btnDisabled = false
                    });
            }

        },



        submitResetForm() {
            // this.loginbox = false;

            if (this.valid) {
                // this.emailsentMsg = true
                // this.forgotshow = false
                this.loadforget = true

                this.forgetDetails.email = this.resetDetail.resetMail
                this.forgetDetails.user_id = this.resetDetail.resetMail


                console.log(this.forgetDetails, 'reqqqqqqqqqq')

                axios.post(this.forgotPassword, this.forgetDetails, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })

                    .then(response => {
                        console.log(response, 'rrrreeeeeessssssss.....')
                        this.loadforget = false
                        if (response.data.forgot_password_response == 'success') {
                            this.forgotshow = false
                            this.emailsentMsg = true
                        }

                        else if (response.data.forgot_password_response == 'fail') {
                            this.forgotshow = true
                            this.emailsentMsg = false
                            this.loadforget = false
                            this.errforget = true
                        }
                    })
                    .catch(errors => {
                        console.log(errors, 'eeerrrrooorrr')
                        this.forgotshow = true
                    })

            }
        },

        closeLoginBox() {
            this.loginbox = false;
            this.$emit('close'); // Emit the 'close' event to the parent component
            console.log(this.loginbox, "1111111")
        },

        getConfig() {
            // let portalLocal = localStorage.getItem("portalData")
            // let getConfigData1 = JSON.parse(portalLocal)
            const getConfigData1 = getConfigDataFromLocalStorage();
            if (getConfigData1) {
                this.loginUrl = getConfigData1.payload.portal_configuration.API_endpoints.b2clogin
                this.registerUrl = getConfigData1.payload.portal_configuration.API_endpoints.b2cregister
                this.forgotPassword = getConfigData1.payload.portal_configuration.API_endpoints.forgot_password
                
                console.log(this.loginUrl, 'head...reg..1..')
                this.dataloader = false
            }
        },




        // Regiter code

        signInAgain(){
    //   this.loginSection = true 
      this.loginbox = true
      this.registerbox = false
      console.log(this.loginSection, this.registerbox, "Workinglogin....")
    },
    // closeRegBox() {
    //         this.loginbox = false;
    //         this.$emit('close'); // Emit the 'close' event to the parent component
    //         console.log(this.loginbox, "1111111")
    //     },


    // onClickOutside() {
    //   this.registerbox = false
    // },
    registerSubmitForm() {

      console.log(this.valid, 'oooooooooo')
      if (this.valid) {

        this.loadRegister = true
        this.btnDisabled = true

        // this.generateBookingRefId()

        console.log(this.personal, 'eeeee......')

        this.registerReq.user_name = this.personal.username
        this.registerReq.email = this.personal.email
        this.registerReq.password = this.personal.password
        this.registerReq.user_id = this.personal.email


        console.log(this.registerReq, 'ffff.....')

        axios.post(this.registerUrl, this.registerReq, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(response => {

            if (response.data) {
              this.regForm = false
              this.regMsg = true
              console.log('Response:', response.data);
              console.log('Response-Msg:', response.data.register.message);
              this.registerMsg = response.data.register.message

              // this.registerbox = false
            }
          })


          .catch(error => {
            console.log(error.response.data.message, 'wejjfuoajk')
            alert(`${error.response.data.message}`)
            this.loadRegister = false
            this.btnDisabled = false
          });
      }
    },




    // getRandomChars(length) {
    //         let result = "";
    //         for (let i = 0; i < length; i++) {
    //             const randomIndex = Math.floor(Math.random() * this.strResult.length);
    //             result += this.strResult[randomIndex];
    //         }
    //         console.log(result, "result");
    //         return result;
    //     },
    //     getRandomInt(min, max) {
    //         return Math.floor(Math.random() * (max - min + 1)) + min;
    //     },

    //     generateBookingRefId() {
    //         const randomChars1 = this.getRandomChars(1);
    //         const randomNum = this.getRandomInt(10, 99);
    //         const randomChars2 = this.getRandomChars(1);

    //         this.registerReq.user_id = randomChars1 + randomNum + randomChars2;
    //         console.log(this.registerReq.user_id, 'this.booking_refId ')
    //     },




    closeRegisterBox() {
      this.registerbox = false;
      this.$emit('close'); // Emit the 'close' event to the parent component
      console.log(this.registerbox, '00000')
    },



    // getConfig() {
    //   // let portalLocal = localStorage.getItem("portalData")
    //   // let getConfigData1 = JSON.parse(portalLocal)
    //   const getConfigData1 = getConfigDataFromLocalStorage();
    //   if (getConfigData1) {
    //     this.registerUrl = getConfigData1.payload.portal_configuration.API_endpoints.b2cregister
    //     console.log(this.registerUrl, 'head...reg..1..')
    //   }
    // },





    },

    created() {
        this.getConfig();
    }
}
</script>



<style scoped>

.f-size-14{
    font-size: 14px;
}
.f-size-12{
    font-size: 12px;
}



.lockIcon{
    background-color: #F8A21A;
    height: 50px;
    width: 50px;
}


/* Login Page */

.main-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

/* .form-btn {
  padding-left: 40px;
  color: white;
} */

.btn-box {
    background-color: transparent;
    margin: 5px;
    padding: 2px;
    box-shadow: none;
}

.btn-active {
    background-color: blueviolet;
    color: white;
}

.v-checkbox .v-input__details {
    display: none;
}

>>>.v-label--clickable {
    cursor: pointer;
    font-size: 12px;
}

>>>.v-input__details {
    display: block !important;
}

.forgotStyle {
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 1px;
    color: #0D6EFD;
    text-decoration: underline;
    cursor: pointer;
    text-align: end;
}

/* Login Page End */



@media only screen and (max-width: 992px) {

    .form-btn {
        padding: 10px 0px 0px 0px !important;
        /* color: white; */
    }

    .btn-box,
    .pipe {
        color: blueviolet !important;
    }

    .btn-active {
        background-color: blueviolet;
        color: white !important;
    }
}



/* Register code */

.main-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* .form-btn {
  padding-left: 40px;
  color: white;
} */

.btn-box {
  background-color: transparent;
  margin: 5px;
  padding: 2px;
  box-shadow: none;
}

.btn-active {
  background-color: blueviolet;
  color: white;
}

>>>.v-input__details {
  display: block !important;
}


/* .v-checkbox .v-input__details {
  display: none;
} */

/* Login Page End */



@media only screen and (max-width: 992px) {

  .form-btn {
    padding: 10px 0px 0px 0px !important;
    /* color: white; */
  }

  .btn-box,
  .pipe {
    color: blueviolet !important;
  }

  .btn-active {
    background-color: blueviolet;
    color: white !important;
  }
}



</style>
